import { moduleStyleType } from 'components/no-ui/styles/styleTypes'

export const DisplayNameDetailsStyles: moduleStyleType = {
    container: {
        cursor: 'pointer',
    },
    label: {
        '&.MuiTypography-root': {
            color: 'primary.main',
            cursor: 'pointer',
        },
    },
    wordBreak: {
        wordBreak: 'break-word',
        lineHeight: 'normal',
    },
    item: {
        marginY: 0,
        marginX: 2,
    },
    itemLessMargin: {
        marginTop: 0,
        marginBottom: 0,
        marginLeft: 0,
        marginRight: 2,
    },
    padded: {
        marginTop: 2,
        marginBottom: 2,
    },
}
